







import { Component, Vue } from 'vue-property-decorator';
import OverdueInvoiceList from '@/components/Invoicing/Invoice/OverdueInvoiceList.vue';

@Component({
  components: {
    OverdueInvoiceList,
  },
})
export default class OverdueInvoices extends Vue {}
